<template>
  <div class="word-list4">
    <div
      class="head"
      :style="{
        backgroundImage: 'url(' + dataInfo.cover + ')'
      }"
    >
      {{ dataInfo.name }}
    </div>
    <div class="g-box">
      <div class="content">
        <div class="inner" v-for="(item, i) in dataList" :key="i">
          <div class="item">
            <div
              class="item-le"
              :style="{
                backgroundImage: 'url(' + item[0].image + ')'
              }"
            >
              <div class="mask"></div>
              <div class="title">{{ item[0].title }}</div>
              <div class="subtitle">{{ item[0].subtitle }}</div>
            </div>
            <div
              class="item-ri"
              :style="{
                backgroundImage: 'url(' + item[1].image + ')'
              }"
            >
              <div class="mask mask1"></div>
              <div class="title">{{ item[1].title }}</div>
              <div class="subtitle">{{ item[1].subtitle }}</div>
            </div>
          </div>
          <div class="item reserve">
            <div
              class="item-le"
              :style="{
                backgroundImage: 'url(' + item[2].image + ')'
              }"
            >
              <div class="mask mask2"></div>
              <div class="title">{{ item[2].title }}</div>
              <div class="subtitle">{{ item[2].subtitle }}</div>
            </div>
            <div
              class="item-ri"
              :style="{
                backgroundImage: 'url(' + item[3].image + ')'
              }"
            >
              <div class="mask mask3"></div>

              <div class="title">{{ item[3].title }}</div>
              <div class="subtitle">{{ item[3].subtitle }}</div>
            </div>
          </div>
          <div class="item">
            <div
              class="item-le"
              :style="{
                backgroundImage: 'url(' + item[4].image + ')'
              }"
            >
              <div class="mask mask4"></div>

              <div class="title">{{ item[4].title }}</div>
              <div class="subtitle">{{ item[4].subtitle }}</div>
            </div>
            <div
              class="item-ri"
              :style="{
                backgroundImage: 'url(' + item[5].image + ')'
              }"
            >
              <div class="mask mask5"></div>

              <div class="title">{{ item[5].title }}</div>
              <div class="subtitle">{{ item[5].subtitle }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 999,
        menuId: this.query.id
      });
      const arr = [];
      for (let i = 0; i < data.length; i += 6) {
        arr.push(data.slice(i, i + 6));
      }
      this.dataList = arr;
      const dataInfo = await this.getMenuInfo(this.query.id);
      this.dataInfo = dataInfo;
      console.log(this.dataList, "dataList");
    }
  }
};
</script>
<style lang="less">
.word-list4 {
  .head {
    height: 280px;
    // width: 1920px;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 60px;
    color: #fff;
    letter-spacing: 40px;
  }
  .content {
    padding-bottom: 120px;
    padding-top: 80px;
    .inner {
      margin-top: 80px;
    }
    .inner:first-child {
      margin-top: 0;
    }
    .item {
      display: flex;
      overflow: hidden;
      &-le,
      &-ri {
        position: relative;
        padding: 40px 30px;
        width: 800px;
        height: 240px;
        background-image: url("../../assets/img/develop-bg.png");
        box-sizing: border-box;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
        .mask {
          position: absolute;
          left: 0;
          top: 0;
          content: "";
          width: 100%;
          height: 100%;
          background-color: #2355ef;
          transform: translate(0, 240px);
          transform-origin: bottom;
          transition: all 0.5s cubic-bezier(0.2, 0, 0.2, 1);
        }
        .mask1 {
          background-color: #9525af;
        }
        .mask2 {
          background-color: #00aace;
        }
        .mask3 {
          background-color: #00b68a;
        }
        .mask4 {
          background-color: #f8b500;
        }
        .mask5 {
          background-color: #00aace;
        }
        .title {
          position: relative;
          font-size: 24px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #fff;
        }
        .subtitle {
          font-family: PingFangSC-Regular, PingFang SC;
          color: #fff;
          line-height: 24px;
          opacity: 0;
          transform: translate(0, 1px);
          transform-origin: bottom;
          transition: transform 0.5s cubic-bezier(0.2, 0, 0.2, 1),
            opacity 0.3s cubic-bezier(0.2, 0, 0.2, 1);
        }
      }
      &-le:hover {
        .mask {
          transform: translate(0, 0px);
        }
        .subtitle {
          opacity: 1;
        }
      }
      &-ri {
        width: 400px;
        height: 240px;
      }
      &-ri:hover {
        .mask {
          transform: translate(0, 0px);
        }
        .subtitle {
          opacity: 1;
        }
      }
    }
    .item.reserve {
      .item-le {
        width: 400px;
        height: 240px;
      }
      .item-ri {
        width: 800px;
        height: 240px;
      }
    }
  }
}
</style>
